var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.title))]),_c(_vm.currentRole,{tag:"component",attrs:{"dash":_vm.dash}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }